import {apiClient} from "@/api/setupApi"

const BASE_API = "v1/admin-news"
const PUBLIC_API = "v1/news"

export default {
  getNews(params?: any): Promise<any> {
    return apiClient.get(BASE_API, {params})
  },
  getNewsById(id: number | string): Promise<any> {
    return apiClient.get(`${BASE_API}/${id}`)
  },
  createNews(payload: {
    title: string
    short_text: string
    text: string
    is_active: boolean
    image?: string
  }): Promise<any> {
    return apiClient.post(BASE_API, payload)
  },
  updateNews(id: number | string, payload: Partial<{
    title: string
    short_text: string
    text: string
    is_active: boolean
    image: string
  }>): Promise<any> {
    return apiClient.patch(`${BASE_API}/${id}`, payload)
  },
  deleteNews(id: number | string): Promise<any> {
    return apiClient.delete(`${BASE_API}/${id}`)
  },
  deactivateAllNews(): Promise<any> {
    return apiClient.post(`${BASE_API}/deactivate-all`)
  },
  // Public API methods for users
  getPublicNews(params?: any): Promise<any> {
    return apiClient.get(PUBLIC_API, {params})
  },
  getPublicNewsById(id: number | string): Promise<any> {
    return apiClient.get(`${PUBLIC_API}/${id}`)
  },
}

